import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home.vue'
import ProductCenter from '@/views/productCenter/ProductCenter.vue'
import ProductDetails from '@/views/productDetails/ProductDetails.vue'
import Solution from '@/views/solution/Solution.vue'
// import StyleShow from '@/views/styleShow/StyleShow.vue'
import Purchase from '@/views/purchase/Purchase.vue'
import SolutionDetails from '@/views/solutionDetails/SolutionDetails.vue'
import News from '@/views/news/News.vue'
import NewsDetails from '@/views/newsDetails/NewsDetails.vue'
import SuccessfulCase from '@/views/successfulCase/SuccessfulCase.vue'
import SuccessfulCaseDetails from '@/views/successfulCaseDetails/SuccessfulCaseDetails.vue'
import AboutUs from '@/views/aboutUs/AboutUs.vue'
import CompanyProfile from '@/views/aboutUs/companyProfile/CompanyProfile.vue'
import HonoraryIntroduction from '@/views/aboutUs/honoraryIntroduction/HonoraryIntroduction.vue'
import EnterpriseCulture from '@/views/aboutUs/enterpriseCulture/EnterpriseCulture.vue'
import ContactUs from '@/views/contactUs/ContactUs.vue'
import User from '@/api/user.js'

Vue.use(Router)

// 解决Vue Router重复导航错误
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/productCenter',
      name: 'ProductCenter',
      component: ProductCenter
    },
    {
      path: '/productDetails',
      name: 'ProductDetails',
      component: ProductDetails
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution
    },
    {
      path: '/solutionDetails',
      name: 'SolutionDetails',
      component: SolutionDetails
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsDetails',
      name: 'NewsDetails',
      component: NewsDetails
    },
    {
      path: '/successfulCase',
      name: 'SuccessfulCase',
      component: SuccessfulCase
    },
    {
      path: '/successfulCaseDetails',
      name: 'SuccessfulCaseDetails',
      component: SuccessfulCaseDetails
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      redirect: '/aboutUs/companyProfile',
      component: AboutUs,
      children: [
        {
          path: '/aboutUs/honoraryIntroduction',
          name: 'HonoraryIntroduction',
          component: HonoraryIntroduction
        },
        {
          path: '/aboutUs/enterpriseCulture',
          name: 'EnterpriseCulture',
          component: EnterpriseCulture
        },
        {
          path: '/aboutUs/companyProfile',
          name: 'CompanyProfile',
          component: CompanyProfile
        }
      ]
    },
    // {
    //   path: "/styleShow",
    //   name: "StyleShow",
    //   component: StyleShow
    // },
    // 新增20260618
    {
      path: '/purchase',
      name: 'Purchase',
      component: Purchase
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs
    }
  ]
})

// 全局前置守卫 - 统一处理token检查和自动登录
router.beforeEach(async (to, from, next) => {
  try {
    // 检查是否是刷新后的页面
    const isAfterRefresh = sessionStorage.getItem('afterTokenRefresh')

    // 检查token状态
    const existingToken = localStorage.getItem('receptionToken')

    if (!existingToken) {
      // 如果没有token，进行自动登录
      console.log(`访问页面 ${to.name}，无token，准备自动登录...`)

      try {
        await autoLogin()
        console.log('自动登录成功，准备刷新页面以加载数据...')

        // 设置刷新标记
        sessionStorage.setItem('afterTokenRefresh', 'true')

        // 刷新页面确保组件重新初始化
        setTimeout(() => {
          window.location.reload()
        }, 100)

        return // 不执行next()，因为页面会刷新
      } catch (error) {
        console.error('自动登录失败:', error)
        // 登录失败时仍然允许访问页面，但会显示加载状态
        next()
        return
      }
    }

    // 如果刚刚刷新过页面，清除标记
    if (isAfterRefresh) {
      sessionStorage.removeItem('afterTokenRefresh')
      console.log(`登录成功，当前访问页面: ${to.name}`)
    }

    // 更新导航状态
    updateNavigationState(to.name)

    // 继续路由导航
    next()
  } catch (error) {
    console.error('路由守卫执行失败:', error)
    next() // 出错时仍然允许导航
  }
})

// 自动登录函数
async function autoLogin () {
  const params = {
    userName: 'font-user',
    password: 'admin'
  }

  const { code, msg, data } = await User.Login(params)

  if (code === 200) {
    // 清除旧的token
    localStorage.removeItem('receptionToken')
    localStorage.removeItem('receptionRefreshToken')

    // 存储新的token
    if (typeof data === 'object' && data.token) {
      localStorage.setItem('receptionToken', data.token)
      if (data.refreshToken) {
        localStorage.setItem('receptionRefreshToken', data.refreshToken)
      }
    } else {
      localStorage.setItem('receptionToken', data)
    }
  } else {
    throw new Error(msg || '登录失败')
  }
}

// 更新导航状态函数
function updateNavigationState (routeName) {
  const routeToIndexMap = {
    'Home': 0,
    'ProductCenter': 1,
    'Solution': 2,
    'News': 3,
    'SuccessfulCase': 4,
    'StyleShow': 5,
    'AboutUs': 6,
    'CompanyProfile': 6,
    'HonoraryIntroduction': 6,
    'EnterpriseCulture': 6,
    'ContactUs': 7
  }

  const currentIndex = routeToIndexMap[routeName] || 0

  // 使用Vue全局实例来更新状态（如果存在）
  if (window.Vue && window.Vue.prototype.$LocalCache) {
    window.Vue.prototype.$LocalCache.setCath('navigationBarIndex', currentIndex)
  }

  // 直接操作localStorage作为备用
  localStorage.setItem('navigationBarIndex', currentIndex.toString())
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js